module.exports = __webpack_public_path__ + "img/appStore.7bc68fba.png";